import React, { useEffect, useState } from 'react';
import { Tooltip, Modal } from 'antd';
import * as Yup from 'yup';
import { UploadFile, Visibility } from '@app/components';
import { Button, FormSubmitButton, FormTextArea, MasterDetailForm, Row } from '@digital/ui';
import { ISasPropostaOrdemCompra, ISasPropostaOrdemCompraDocs, updateDesobrigarConfide } from '@app/api/sas/sasProposta';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { editandoState, modalAcoesIdState, vendorListDocsState } from '../atoms';
import { isObjNotEmpty, vtObjToFormData } from '@app/helpers/objHelper';
import ModalConfirmContentJustificativa from '@app/components/ModalConfirmContent/ModalConfirmContentJustificativa';
import { IArquivo } from '@app/types/core.types';

interface Props {
    sasProposta: ISasPropostaOrdemCompra;
}

const ModalDesobrigarRelatorioFinanceiro = ({ sasProposta }: Props) => {

    const setModalAcoesId = useSetRecoilState(modalAcoesIdState);
    const editando = useRecoilValue(editandoState);
    const vendorListDocs = useRecoilValue(vendorListDocsState);

    const isDisabled = editando.sasPropostaId !== sasProposta.id
        && ["Desobrigado", "Não Aplicável"].includes(sasProposta.statusResultadoEnvioConfide);

    const title = 'Desobrigar Relatório Financeiro';

    const [exibirModal, setExibirModal] = useState(false);
    const [doc, setDoc] = useState<ISasPropostaOrdemCompraDocs>({} as ISasPropostaOrdemCompraDocs);

    useEffect(() => {
        var doc = vendorListDocs.find(f => f.id == sasProposta.id);
        if (isObjNotEmpty(doc)) {
            setDoc(doc || {} as ISasPropostaOrdemCompraDocs);
        }
    }, [exibirModal]);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleCancelAndClose = () => {
        setExibirModal(false);
        setModalAcoesId('');
    };

    const handleSubmit = (values: any) => {
        Modal.confirm({
            title: '',
            content: `Confirma desobrigrar do Relatório Financeiro ?`,
            cancelText: 'Cancelar',
            onCancel: () => { },
            okText: 'Confirmar',
            onOk: () => {
                const form = vtObjToFormData(values);
                form.append('sasPropostaId', sasProposta.id);

                if (editando.sasPropostaId == sasProposta.id) {
                    Modal.confirm({
                        title: <>{editando.justificativa}</>,
                        content: <ModalConfirmContentJustificativa
                            texto='É necessário informar a justificativa para a alteração.'
                            setJustificativa={e => {
                                form.set('justificativaEdicao', e);
                            }}
                        />,
                        okText: 'Confirmar',
                        cancelText: 'Cancelar',
                        onOk: async () => {
                            form.append('editando', 'true');
                            return new Promise((resolve, reject) => {
                                updateDesobrigarConfide(form)
                                    .then((data: any) => {
                                        if (data && data.valid) {
                                            handleCancelAndClose();
                                        } else {
                                            if (data.notifications && data.notifications.length > 0) {
                                                const erroJustificativaEdicao = data.notifications.findIndex((c: any) => {
                                                    return c.property == 'justificativaEdicao';
                                                });
                                                if (erroJustificativaEdicao >= 0) {
                                                    return reject(false);
                                                }
                                            }
                                        }
                                        return resolve(true);
                                    });
                            });
                        },
                        onCancel: handleCancelAndClose
                    });
                } else {
                    updateDesobrigarConfide(form)
                        .then((data: any) => {
                            if (data && data.valid) {
                                handleCancelAndClose();
                            }
                        });
                }
            }
        });
    };

    return (
        <>
            <Tooltip title={title} >
                <Button icon='files-check_file_filled2' onClick={() => { setExibirModal(true); }} />
            </Tooltip>

            <Visibility visible={exibirModal}>

                <Modal title={title} width='780px' visible={exibirModal} onCancel={handleCancel} footer={null} >
                    <MasterDetailForm
                        key={`formDesobrigarRelatorioFinanceiro_${sasProposta.id}`}
                        actions={[
                            <Button title='fechar' type='link' onClick={handleCancel} />,
                            <Visibility visible={!isDisabled}>
                                <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                            </Visibility>
                        ]}
                        initialValues={{
                            justificativa: sasProposta.comentarioDesobrigrarConfide,
                        }}
                        validationSchema={
                            Yup.object().shape({
                                justificativa: Yup.string().required(`O campo Justificativa é obrigatório.`)
                            })
                        }
                    >
                        <Row>
                            <FormTextArea
                                name="justificativa"
                                label='Justificativa'
                                span={12}
                                disabled={isDisabled}
                                rows={4}
                                maxLength={2000} />
                        </Row>
                        <Row>
                            <UploadFile
                                idDoComponente='anexoDesobrigrarConfide'
                                type='primary'
                                hasLabel={true}
                                icon='ui-upload'
                                span={6}
                                showUpload={!isDisabled}
                                onGetArquivo={() => {

                                    if (isObjNotEmpty(doc.anexoDesobrigrarConfide)) {
                                        return Promise.resolve({
                                            id: doc.anexoDesobrigrarConfide.id,
                                            nome: doc.anexoDesobrigrarConfide.nome,
                                            status: "",
                                            statusArquivoId: doc.anexoDesobrigrarConfide.statusArquivoId || "",
                                        } as IArquivo);
                                    }
                                    return Promise.resolve(undefined);

                                }}
                                showDownload={isObjNotEmpty(doc.anexoDesobrigrarConfide)}
                            />
                        </Row>
                    </MasterDetailForm>
                </Modal>

            </Visibility>

        </>
    );
};

export default ModalDesobrigarRelatorioFinanceiro;
